import { StylesConfig } from 'react-select';

import { DropdownSelectStylesOptionsType } from './config/types';

export const getDropdownSelectStyles = ({
  hideSearch,
  listMaxHeight,
}: DropdownSelectStylesOptionsType): StylesConfig => ({
  container: (base) => ({
    ...base,
  }),
  control: (base, { isFocused }) => ({
    ...base,
    display: hideSearch ? 'none' : base.display,
    padding: '12px 16px',
    borderRadius: '12px',
    backgroundColor: 'transparent',
    borderColor: isFocused ? 'var(--purpleflat)' : 'rgba(var(--bg3-rgb), .2)',
    borderWidth: 2,
    boxShadow: 'none',
    fontSize: '18px',
    lineHeight: '24px',
    ':hover': {
      borderColor: 'var(--purpleflat)',
      cursor: 'pointer',
    },
  }),
  valueContainer: (base) => ({
    ...base,
    padding: 0,
    color: 'var(--bw)',
  }),
  input: (base) => ({
    ...base,
    padding: 0,
    margin: 0,
    color: 'var(--bw)',
  }),
  menu: (base) => ({
    ...base,
    position: 'relative',
    margin: 0,
    backgroundColor: 'transparent',
    boxShadow: 'none',
  }),
  menuList: (base) => ({
    ...base,
    margin: '12px 0 0 0',
    padding: 0,
    position: 'relative',
    maxHeight: listMaxHeight || base.maxHeight,
  }),
  option: (base, { isMulti }) => ({
    ...base,
    padding: '12px 16px',
    backgroundColor: 'transparent',
    borderRadius: '12px',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'right 18px center',
    cursor: 'pointer',
    color: 'var(--bw)',
    ':active': {
      backgroundColor: 'transparent',
    },
    ':hover': {
      boxShadow: isMulti ? 'inset 0 0 0 2px var(--purpleflat)' : 'none',
    },
    ':not(:last-child)': {
      marginBottom: '4px',
    },
  }),
});
